/**
 * @generated SignedSource<<06743b0678d8774cd5fce06af8471cde>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraEmailMimeType = "HTML" | "TEXT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField$data = {
  readonly emailMimeType: JiraEmailMimeType;
  readonly id: string;
  readonly isEmailMimeTypeEditable: boolean;
  readonly " $fragmentType": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField";
};
export type mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField$key = {
  readonly " $data"?: mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField$data;
  readonly " $fragmentSpreads": FragmentRefs<"mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "emailMimeType"
      },
      "action": "THROW",
      "path": "emailMimeType"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isEmailMimeTypeEditable"
      },
      "action": "THROW",
      "path": "isEmailMimeTypeEditable"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "46917d18330cb3a196b7f51f1ccdb2d0";

export default node;
